module.exports = __webpack_public_path__ + "img/icon-stage.020928f5.png";